<script setup lang="ts">
/**
 * Toggle Item — a pill that is either on or off (single or multi choice).
 * Figma: instances in Quizzes (Heels, Gender, Details) and Personal data.
 */
interface FairToggleItemProps {
  label: string
  selected?: boolean
  disabled?: boolean
  /** Fills the row (`flex: 1`) — Gender on quizzes. */
  stretch?: boolean
  /** Tall variant of the quiz Gender row (56px). */
  large?: boolean
  /** `auto` — Size=Mobile (44 hit) below 1024; `default` — always the 30px desktop pill. */
  size?: 'auto' | 'default'
  /** In a `radiogroup`: `role="radio"` + `aria-checked` instead of `aria-pressed`. */
  radio?: boolean
}

withDefaults(defineProps<FairToggleItemProps>(), {
  selected: false,
  disabled: false,
  stretch: false,
  large: false,
  size: 'auto',
  radio: false,
})

const emit = defineEmits<{
  click: [event: MouseEvent]
}>()
</script>

<template>
  <button
    type="button"
    class="fair-toggle-item"
    :class="{
      'fair-toggle-item--selected': selected,
      'fair-toggle-item--stretch': stretch,
      'fair-toggle-item--large': large,
      'fair-toggle-item--fixed': size === 'default',
    }"
    :role="radio ? 'radio' : undefined"
    :aria-checked="radio ? selected : undefined"
    :aria-pressed="radio ? undefined : selected"
    :disabled="disabled"
    @click="emit('click', $event)"
  >
    <slot>{{ label }}</slot>
  </button>
</template>
